import moment from 'moment';

export const COLORS = ['#0acf97', '#727cf5', '#6c757d', '#fa5c7c', '#ffbc00', '#39afd1', '#e3eaef'];

export const RED_COLORS = ['#FF0000', '#CC0000', '#FF3333', '#990000', '#FF6666', '#FFCCCC', '#FF9999'];

export const BLUE_COLORS = [ '#0000FF', '#00FFFF', '#0000CC', '#000099','#6666FF', '#66B2FF', '#CCE5FF'];

const convertToUnixTime = timestamp => moment(timestamp).format('x');

const formatUnixTime = (unixTime, format) => {
	const currentOffset = moment().utcOffset();
	return moment(Number(unixTime)).utcOffset(currentOffset).format(format || 'MMM D');
};

const prepareTimeSeriesData = (data) => {
	return data && data.map(item => {
		const { timestamp, ...rest } = item;
		return {
			timestamp: convertToUnixTime(timestamp),	// convert dates to Unix Timestamp to use with scale='time' type='number'
			...rest
		};
	});
};

const formatPieLegendItem = (value, entry) => `${(entry.payload.percent * 100).toFixed(0)}% ${value}`;

const formatPercentage = value => `${value}%`;

export default {
	convertToUnixTime,
	formatUnixTime,
	prepareTimeSeriesData,
	formatPieLegendItem,
	formatPercentage
};